import { createSelector } from "reselect";

const templateListSelector = (state: TReduxState) =>
  state.features.templateList;

export const getTemplateList = createSelector(
  templateListSelector,
  (templateList) => templateList.templateList
);

export const getTemplatePagination = createSelector(
  templateListSelector,
  (templateList) => templateList.templatePagination
);

export const getTemplateResetStatus = createSelector(
  templateListSelector,
  (templateList) => templateList.isReset
);
